import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

type OptionType = {
	id: number;
	text: string;
	code: string;
}

type Props = {
	selectedFormat: OptionType;
	setSelectedFormat: (format: OptionType) => void;
	options: OptionType[];
}

export default function CourseFormatsSelect({ selectedFormat, setSelectedFormat, options }: Props) {
	const [open, setOpen] = useState(false);
	const [_, setSearchedFormat] = useState("");

	return (
		<div className={`relative cursor-not-allowed px-4 rounded-lg bg-inputColor shadow-dashboard-setup-input h-max ${!options? 'hidden' : ''}`}>
			<label className='block lg:text-base cursor-not-allowed'>Format de cours</label>
			<Autocomplete
				sx={{ "& .MuiOutlinedInput-root": { fontFamily: "nunito" } }}
				id="dubjects-select"
				fullWidth
				open={open}
				classes={{}}
				onOpen={() => {
					setOpen(true);
				}}
				onClose={() => {
					setOpen(false);
				}}
				noOptionsText="Aucun format ne correspond au terme recherché."
				multiple={false}
				clearIcon=""
				value={selectedFormat} // Utilise l'état pour contrôler la valeur
				onChange={(event, newValue) => {
					if (newValue) {
						setSelectedFormat(newValue);
					}
				}}
				isOptionEqualToValue={(option, value) => option?.code === selectedFormat.code}
				getOptionLabel={(option) => option?.text}
				options={options}
				// loading={loading}
				loadingText="chargement ..."
				popupIcon=""
				renderTags={(value, getTagProps) =>
					value.map((option, index) => (
						<span
							key={index}
							className="font-nunito lg:text-lg md:text-md text-sm"
						>
						  {option.text}
						</span>
					))
				}
				renderInput={(params) => (
					<TextField
						{...params}
						variant="standard"
						placeholder="Selectionnez un format de cours"
						onChange={(e) => setSearchedFormat(e.target.value)}
						InputProps={{
							...params.InputProps,
							startAdornment: <span className=""></span>,
							type: "search",
						}}
						sx={{
							width: "100%",
							paddingTop: '-3rem',
							"& .MuiInputBase-root": {
								width: "100%",
								border: "none"
							},
							"& .MuiInputBase-input": {
								width: "100%",
								fontFamily: "nunito",
								border: "none"
							},
							"& fieldset": {
								border: "none",
							},
						}}
					/>
				)}
			/>
		</div>
	);
}